import React from 'react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import PropTypes from 'prop-types';
import CustomInputDate from './components/CustomInputDate';
import './CustomDatePicker.css';
import "react-datepicker/dist/react-datepicker.css";

class CustomDatePicker extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        const { customClass
        } = this.props;

        return (
            <div>
                <DatePicker
                    customInput={(
                        <CustomInputDate
                            customClass={customClass}
                        />
                    )}
                    dateFormat='dd/MM/yyyy'
                    {
                    ...this.props
                    }
                />
            </div>
        )
    }
}

export default CustomDatePicker;